var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValorant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.657V3.10331C23 2.97138 22.8351 2.9164 22.7471 3.01536L13.4018 14.6915C13.3248 14.7795 13.3908 14.9224 13.5117 14.9224H20.2624C20.4493 14.9224 20.6142 14.8344 20.7241 14.6915L22.8571 12.0308C22.945 11.9319 23 11.8 23 11.657ZM1.14293 12.0418L8.15742 20.8155C8.26737 20.9584 8.44328 21.0353 8.63018 21.0353H15.3808C15.5017 21.0353 15.5677 20.9034 15.4908 20.8155L1.25287 3.02635C1.16492 2.9274 1 2.98237 1 3.11431V11.668C1.01099 11.8 1.05497 11.9319 1.14293 12.0418Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValorant);
export default __webpack_public_path__ + "static/media/valorant.da9be1fcdc5c39124f6511b1307c0fd8.svg";
export { ForwardRef as ReactComponent };